import { useEffect, useState } from 'react';

// true enquanto a media query vale; acompanha o redimensionamento da janela e o giro do aparelho.
// Sem window.matchMedia (testes no jsdom, navegador muito antigo), devolve o fallback
export function useMediaQuery(query, fallback = false) {
  const [matches, setMatches] = useState(() => (window.matchMedia ? window.matchMedia(query).matches : fallback));

  useEffect(() => {
    if (!window.matchMedia) return undefined;

    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();

    // Safari/iOS anteriores ao 14 só têm addListener
    if (!list.addEventListener) {
      list.addListener(update);
      return () => list.removeListener(update);
    }

    list.addEventListener('change', update);
    return () => list.removeEventListener('change', update);
  }, [query]);

  return matches;
}
